module.exports = __webpack_public_path__ + "img/WorkflowMainImage.2972e7cd.png";